import axios from "axios";

const url = process.env.REACT_APP_API_URL_PBUMKU
const urlUmkuOss = process.env.REACT_APP_API_URL_PBUMKU_OSS
const contentType = 'application/json'

export default class PbUmkuService {

    syncNibFromOss(nib) {
        return axios.get(urlUmkuOss + '/get_data_oss.php?cari=' + nib)
    }

    ambilNomorService(jenisPenomoran, kodePusat, tahunAgenda, username) {
        return axios.get(url + '/ambil-nomor?jenisPenomoran=' + jenisPenomoran + '&kodePusat=' + kodePusat + '&tahunAgenda=' + tahunAgenda + '&username=' + username)
    }

    listPenandatangan(nama = null, page, size) {
        let param = ''
        if (nama !== null) {
            param += '&nama=' + nama
        }
        return axios.get(url + '/penandatangan?page=' + page + '&size=' + size + param)
    }

    getPenandatanganByNip(nip) {
        return axios.get(url + '/penandantangan/' + nip)
    }

    listDataOss(kdIzin, nib = null, kdUnit = null, statusChecklist = null, page, size) {
        let param = ''
        if (nib !== null) {
            param += '&nib=' + nib
        }
        if (kdUnit !== null) {
            param += '&kdUnit=' + kdUnit
        }
        if (statusChecklist !== null) {
            param += '&statusChecklist=' + statusChecklist
        }
        return axios.get(url + '/oss-data-list?page=' + page + '&size=' + size + '&kdIzin=' + kdIzin + param)
    }

    listStatusChecklist(keterangan, page, size) {
        let param = ''
        if (keterangan !== null) {
            param += '&keterangan=' + keterangan
        }
        return axios.get(url + '/status-checklist?page=' + page + '&size=' + size + param)
    }

    getStatusChecklistByStatusChecklist(statusChecklist) {
        return axios.get(url + '/status-checklist-by-kode/' + statusChecklist)
    }

    getStatusChecklistById(id) {
        return axios.get(url + '/status-checklist/' + id)
    }

    listOssHeader(nib, page, size) {
        let param = '';
        let stsAktif = '1'
        if (nib !== null) {
            param += '&nib=' + nib
        }
        return axios.get(url + '/oss-header?page=' + page + '&size=' + size + '&stsAktif=' + stsAktif + param)
    }

    getDataOssById(id) {
        return axios.get(url + '/oss-data/' + id)
    }

    getOssHeader(id) {
        return axios.get(url + '/oss-header/' + id)
    }

    ossHeaderList(nib, kdUnit, kdProp, page, size) {
        let param = '';
        if (nib !== null) {
            param += '&nib=' + nib
        }
        if (kdUnit !== null) {
            param += '&kdUnit=' + kdUnit
        }
        if (kdProp !== null) {
            param += '&kdProp=' + kdProp
        }
        return axios.get(url + '/oss-header-list?page=' + page + '&size=' + size + param)
    }

    findOssProyekById(id) {
        return axios.get(url + '/oss-proyek/' + id)
    }

    listOssProyekLokasi(idProyek) {
        return axios.get(url + '/oss-proyek-lokasi?idProyek=' + idProyek)
    }

    findOssChecklistById(id) {
        return axios.get(url + '/oss-checklist/' + id)
    }

    findSptByIdossIdprykIdchecklist(idoss, idpryk, idchecklist) {
        return axios.get(url + '/umku-spt?idoss=' + idoss + '&idpryk=' + idpryk + '&idchecklist=' + idchecklist)
    }

    saveSpt(jsondata) {
        return axios.post(url + '/umku-spt', jsondata, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    listChecklistDokumen(page, size) {
        return axios.get(url + '/checklist-dokumen?page=' + page + '&size=' + size)
    }

    findChecklistDokumenById(id) {
        return axios.get(url + '/checklist-dokumen/' + id)
    }

    saveLaporanHeader(jsondata) {
        return axios.post(url + '/umku-lap-header', jsondata, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    editLaporanHeader(jsondata) {
        return axios.put(url + '/umku-lap-header', jsondata, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    findLaporanHeaderById(id) {
        return axios.get(url + '/umku-lap-header/' + id)
    }

    findLaporanHeaderByIdossIdprykIdchecklistIdspt(idoss, idpryk, idchecklist, idspt) {
        return axios.get(url + '/umku-lap-header?idoss=' + idoss + '&idpryk=' + idpryk + '&idchecklist=' + idchecklist + '&idspt=' + idspt)
    }

    saveLaporanFile(jsondata) {
        return axios.post(url + '/umku-laporan-file', jsondata, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    listLaporanFile(idlaphdr, page, size) {
        let param = '0'
        if (idlaphdr !== 0) {
            param = idlaphdr
        }
        return axios.get(url + '/umku-laporan-file?page=' + page + '&size=' + size + '&idlaphdr=' + param)
    }

    findLaporanFileById(idlapfile) {
        return axios.get(url + '/umku-laporan-file/' + idlapfile)
    }

    listLaporanLampiran(idlaphdr, page, size) {
        let param = '0'
        if (idlaphdr !== 0) {
            param = idlaphdr
        }
        return axios.get(url + '/umku-lap-lampiran?page=' + page + '&size=' + size + '&idlaphdr=' + param)
    }

    findLaporanLampiranById(idlaplamp) {
        return axios.get(url + '/umku-lap-lampiran/' + idlaplamp)
    }

    saveLaporanLampiran(jsondata) {
        return axios.post(url + '/umku-lap-lampiran', jsondata, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    viewTte(idPermohonan) {
        return axios.get(url + '/view-tte/' + idPermohonan)
    }

    //ref-perizinan
    getRefPerizinan(jenisIzin) {
        return axios.get(url + '/ref-perizinan/' + jenisIzin)
    }

    //ref-kategori
    listKategori(uraianKategori, page, size) {
        let param = ''
        if (uraianKategori !== null) {
            param += '&uraianKategori=' + uraianKategori
        }
        return axios.get(url + '/ref-kategori?page=' + page + '&size=' + size + param)
    }
    getKategoriById(kode) {
        return axios.get(url + '/ref-kategori/' + kode)
    }

    //ref-checklist
    listChecklistHeader(kodeSert) {
        return axios.get(url + '/checklist-header?kodeSert=' + kodeSert)
    }

    getChecklistHeaderByKode(kodeHeader) {
        return axios.get(url + '/checklist-header/' + kodeHeader)
    }

    listChecklistHeaderSub(kodeHeader) {
        return axios.get(url + '/checklist-header-sub?kodeHeader=' + kodeHeader)
    }

    getChecklistHeaderSubByKode(kodeHeaderSub) {
        return axios.get(url + '/checklist-header-sub/' + kodeHeaderSub)
    }

    listChecklistKomponen(kodeHeaderSub) {
        return axios.get(url + '/checklist-komponen?kodeHeaderSub=' + kodeHeaderSub)
    }

    getChecklistKomponenByKode(kodeKomponen) {
        return axios.get(url + '/checklist-komponen/' + kodeKomponen)
    }

    listChecklistKomponenSub(kodeKomponen) {
        return axios.get(url + '/checklist-komponen-sub?kodeKomponen=' + kodeKomponen)
    }

    getChecklistKomponenSubByKode(kodeKomponenSub) {
        return axios.get(url + '/checklist-komponen-sub/' + kodeKomponenSub)
    }

    //ref-disposisi
    getDisposisiById(id) {
        return axios.get(url + '/ref-disposisi/' + id)
    }

    //ref-kesimpulan
    listKesimpulanByIdDisposisi(idDisposisi) {
        return axios.get(url + '/ref-kesimpulan/' + idDisposisi)
    }

    getKesimpulanById(id) {
        return axios.get(url + '/ref-kesimpulan-by-id/' + id)
    }

    //ref-jenis-dokumen
    listJenisDokByJenisIzinAndJenisDok(jenisIzin, jenisDok, page, size) {
        return axios.get(url + '/ref-jenis-dok?jenisIzin=' + jenisIzin + '&jenisDok=' + jenisDok + '&page=' + page + '&size=' + size)
    }

    getJenisDokById(id) {
        return axios.get(url + '/ref-jenis-dok/' + id)
    }

    //ref-jenis-sertifikasi
    listJenisSertifikasi(kodeSert, uraianSertifikasi, page, size) {
        let param = ''
        if (uraianSertifikasi !== null) {
            param += '&uraianSertifikasi=' + uraianSertifikasi
        }
        return axios.get(url + '/jenis-sertifikasi?kodeSert=' + kodeSert + param + '&page=' + page + '&size=' + size)
    }

    listJenisSertifikasiAll(kodeSert) {
        return axios.get(url + '/jenis-sertifikasi-all?kodeSert=' + kodeSert)
    }

    getJenisSertifikasi(kodeSert, jenisSert) {
        return axios.get(url + '/jenis-sertifikasi/' + kodeSert + '/' + jenisSert)
    }

    //ref-status
    listStatusPrimer(uraianStatus, page, size) {
        let param
        if (uraianStatus !== null) {
            param += '&uraianStatus=' + uraianStatus
        }
        return axios.get(url + '/ref-status-primer?page=' + page + '&size=' + size + param)
    }

    getStatusPrimerById(kodeStatus) {
        return axios.get(url + '/ref-status-primer/' + kodeStatus)
    }

    //umku-core
    getUmkuHeader(nomorAju) {
        return axios.get(url + '/umku-header/' + nomorAju)
    }

    listUmkuHeaderDraft(kdIzin, nomorAju, nib, asalData, page, size, kdUnit) {
        let param = ''
        if (nomorAju !== null) {
            param += '&nomorAju=' + nomorAju
        }
        if (nib !== null) {
            param += '&nib=' + nib
        }
        if (asalData !== null) {
            param += '&asalData=' + asalData
        }
        if (kdUnit !== null) {
            param += '&kdUnit=' + kdUnit
        }
        return axios.get(url + '/umku-header?kdIzin=' + kdIzin + param + '&kodeStatus=000&page=' + page + '&size=' + size)
    }

    listUmkuHeaderProses(kdIzin, nomorAju, nib, asalData, page, size, kdUnit) {
        let param = ''
        if (nomorAju !== null) {
            param += '&nomorAju=' + nomorAju
        }
        if (nib !== null) {
            param += '&nib=' + nib
        }
        if (asalData !== null) {
            param += '&asalData=' + asalData
        }
        if (kdUnit !== null) {
            param += '&kdUnit=' + kdUnit
        }
        return axios.get(url + '/umku-header?kdIzin=' + kdIzin + param + '&kodeStatus=000&kodeStatus=010&kodeStatus=020&page=' + page + '&size=' + size)
    }

    // listUmkuHeaderProsesST(kdIzin, nomorAju, nib, asalData, page, size) {
    //     let param = ''
    //     if (nomorAju !== null) {
    //         param += '&nomorAju=' + nomorAju
    //     }
    //     if (nib !== null) {
    //         param += '&nib=' + nib
    //     }
    //     if (asalData !== null) {
    //         param += '&asalData=' + asalData
    //     }
    //     return axios.get(url + '/umku-header?kdIzin=' + kdIzin + param + '&kodeStatus=021&kodeStatus=022&kodeStatus=023&page=' + page + '&size=' + size)
    // }

    listUmkuHeaderProsesInspeksi(kdIzin, nomorAju, nib, asalData, page, size, kdUnit) {
        let param = ''
        if (nomorAju !== null) {
            param += '&nomorAju=' + nomorAju
        }
        if (nib !== null) {
            param += '&nib=' + nib
        }
        if (asalData !== null) {
            param += '&asalData=' + asalData
        }
        if (kdUnit !== null) {
            param += '&kdUnit=' + kdUnit
        }
        return axios.get(url + '/umku-header?kdIzin=' + kdIzin + param + '&kodeStatus=021&kodeStatus=022&kodeStatus=023&kodeStatus=024&kodeStatus=025&kodeStatus=026&page=' + page + '&size=' + size)
    }

    listUmkuHeaderProsesEvaluasiRekom(kdIzin, nomorAju, nib, asalData, page, size, kdUnit) {
        let param = ''
        if (nomorAju !== null) {
            param += '&nomorAju=' + nomorAju
        }
        if (nib !== null) {
            param += '&nib=' + nib
        }
        if (asalData !== null) {
            param += '&asalData=' + asalData
        }
        if (kdUnit !== null) {
            param += '&kdUnit=' + kdUnit
        }
        return axios.get(url + '/umku-header?kdIzin=' + kdIzin + param + '&kodeStatus=027&kodeStatus=028&kodeStatus=029&page=' + page + '&size=' + size)
    }

    listUmkuHeaderPersetujuan(kdIzin, nomorAju, nib, asalData, page, size, kdUnit) {
        let param = ''
        if (nomorAju !== null) {
            param += '&nomorAju=' + nomorAju
        }
        if (nib !== null) {
            param += '&nib=' + nib
        }
        if (asalData !== null) {
            param += '&asalData=' + asalData
        }
        if (kdUnit !== null) {
            param += '&kdUnit=' + kdUnit
        }
        return axios.get(url + '/umku-header?kdIzin=' + kdIzin + param + '&kodeStatus=031&page=' + page + '&size=' + size)
    }

    listUmkuHeaderTerbit(kdIzin, nomorAju, nib, asalData, page, size, kdUnit) {
        let param = ''
        if (nomorAju !== null) {
            param += '&nomorAju=' + nomorAju
        }
        if (nib !== null) {
            param += '&nib=' + nib
        }
        if (asalData !== null) {
            param += '&asalData=' + asalData
        }
        if (kdUnit !== null) {
            param += '&kdUnit=' + kdUnit
        }
        return axios.get(url + '/umku-header?kdIzin=' + kdIzin + param + '&kodeStatus=100&page=' + page + '&size=' + size)
    }

    listUmkuHeaderTolak(kdIzin, nomorAju, nib, asalData, page, size, kdUnit) {
        let param = ''
        if (nomorAju !== null) {
            param += '&nomorAju=' + nomorAju
        }
        if (nib !== null) {
            param += '&nib=' + nib
        }
        if (asalData !== null) {
            param += '&asalData=' + asalData
        }
        if (kdUnit !== null) {
            param += '&kdUnit=' + kdUnit
        }
        return axios.get(url + '/umku-header?kdIzin=' + kdIzin + param + '&kodeStatus=110&kodeStatus=120&kodeStatus=130&kodeStatus=131&kodeStatus=132&kodeStatus=133&page=' + page + '&size=' + size)
    }

    saveUmkuHeader(jsonData) {
        return axios.post(url + '/umku-header', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    getUmkuPembenihan(nomorAju) {
        return axios.get(url + '/umku-pembenihan?nomorAju=' + nomorAju)
    }

    saveUmkuPembenihan(jsonData) {
        return axios.post(url + '/umku-pembenihan', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    getUmkuBudidaya(nomorAju) {
        return axios.get(url + '/umku-budidaya?nomorAju=' + nomorAju)
    }

    saveUmkuBudidaya(jsonData) {
        return axios.post(url + '/umku-budidaya', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    listUmkuBudidayaDetail(nomorAju) {
        return axios.get(url + '/umku-budidaya-detail?nomorAju=' + nomorAju)
    }

    getUmkuBudidayaDetailById(jsonData) {
        return axios.post(url + '/umku-budidaya-detail-by-id', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    saveUmkuBudidayaDetail(jsonData) {
        return axios.post(url + '/umku-budidaya-detail', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    deleteUmkuBudidayaDetail(jsonData) {
        return axios.post(url + '/delete-umku-budidaya-detail', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    listUmkuPembenihanDetail(nomorAju) {
        return axios.get(url + '/umku-pembenihan-detail?nomorAju=' + nomorAju)
    }

    getUmkuPembenihanDetailById(jsonData) {
        return axios.post(url + '/umku-pembenihan-detail-by-id', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    saveUmkuPembenihanDetail(jsonData) {
        return axios.post(url + '/umku-pembenihan-detail', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    deleteUmkuPembenihanDetail(jsonData) {
        return axios.post(url + '/delete-umku-pembenihan-detail', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    getNextSeri(tableName, nomorAju) {
        return axios.get(url + '/next-seri?tableName=' + tableName + '&nomorAju=' + nomorAju)
    }

    listUmkuDok(nomorAju) {
        return axios.get(url + '/umku-dok?nomorAju=' + nomorAju)
    }

    getUmkuDokById(jsonData) {
        return axios.post(url + '/umku-dok-by-id', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    saveUmkuDok(jsonData) {
        return axios.post(url + '/umku-dok', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    deleteUmkuDok(jsonData) {
        return axios.post(url + '/delete-umku-dok', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    listUmkuStatus(nomorAju) {
        return axios.get(url + '/umku-status?nomorAju=' + nomorAju)
    }

    saveUmkuStatus(jsonData) {
        return axios.post(url + '/umku-status', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    //umku-penugasan
    listUmkuPenugasanAll(nomorAju) {
        return axios.get(url + '/umku-penugasan-all?nomorAju=' + nomorAju)
    }

    saveUmkuPenugasan(jsonData) {
        return axios.post(url + '/umku-penugasan', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    getUmkuPenugasanByAjuAndIdDisposisi(nomorAju, idDisposisi) {
        return axios.get(url + '/umku-penugasan/' + nomorAju + '/' + idDisposisi)
    }

    getUmkuPenugasanByAjuAndIdDisposisiAndNoTugas(nomorAju, idDisposisi, noTugas) {
        return axios.get(url + '/umku-penugasan?nomorAju=' + nomorAju + '&idDisposisi=' + idDisposisi + '&noTugas=' + noTugas)
        // return axios.get(url + '/umku-penugasan/' + nomorAju + '/' + idDisposisi + '/' + noTugas)
    }

    //umku-inspeksi
    listUmkuBatal(nomorAju) {
        return axios.get(url + '/umku-batal?nomorAju=' + nomorAju)
    }

    getUmkuBatalByAjuAndNoTugas(nomorAju, noTugas) {
        return axios.get(url + '/umku-batal-by-aju-notugas?nomorAju=' + nomorAju + '&noTugas=' + noTugas)
    }

    saveUmkuBatal(jsonData) {
        return axios.post(url + '/umku-batal', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    listUmkuAudit(nomorAju) {
        return axios.get(url + '/umku-audit-kecukupan?nomorAju=' + nomorAju)
    }

    getUmkuAuditByAjuNoTugas(nomorAju, noTugas) {
        return axios.get(url + '/umku-audit-kecukupan-by-aju-no-tugas/' + nomorAju + '/' + noTugas)
    }

    getUmkuAuditById(id) {
        return axios.get(url + '/umku-audit-kecukupan/' + id)
    }

    saveUmkuAudit(jsonData) {
        return axios.post(url + '/umku-audit-kecukupan', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    deleteUmkuAudit(id) {
        return axios.delete(url + '/umku-audit-kecukupan/' + id)
    }

    listUmkuAuditDokByIdInspeksiAudit(idInspeksiAudit) {
        return axios.get(url + '/umku-audit-kecukupan-dok?idInspeksiAudit=' + idInspeksiAudit)
    }

    getUmkuAuditDokById(id) {
        return axios.get(url + '/umku-audit-kecukupan-dok/' + id)
    }

    saveUmkuAuditDok(jsonData) {
        return axios.post(url + '/umku-audit-kecukupan-dok', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    deleteUmkuAuditDok(id) {
        return axios.delete(url + '/umku-audit-kecukupan-dok/' + id)
    }

    getUmkuInspeksiDataByAjuAndIdProses(nomorAju, idProses) {
        return axios.get(url + '/umku-inspeksi-data?nomorAju=' + nomorAju + '&idProses=' + idProses)
    }

    getUmkuInspeksiDataByAjuAndNoSurat(nomorAju, noSurat) {
        return axios.get(url + '/umku-inspeksi-data-by-aju-nosurat?nomorAju=' + nomorAju + '&noSuratTugas=' + noSurat)
    }

    saveUmkuInspeksiData(jsonData) {
        return axios.post(url + '/umku-inspeksi-data', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    deleteUmkuInspeksiDataById(id) {
        return axios.delete(url + '/umku-inspeksi-data/' + id)
    }

    getUmkuInspeksiDataDokByIdInspeksi(idInspeksi) {
        return axios.get(url + '/umku-inspeksi-data-dok/' + idInspeksi)
    }

    getUmkuInspeksiDataDokById(id) {
        return axios.get(url + '/umku-inspeksi-data-dok-by-id/' + id)
    }

    saveUmkuInspeksiDataDok(jsonData) {
        return axios.post(url + '/umku-inspeksi-data-dok', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    deleteUmkuInspeksiDataDok(id) {
        return axios.delete(url + '/umku-inspeksi-data-dok-delete/' + id)
    }

    listUmkuInspeksiChecklistByIdInspeksi(idInspeksi) {
        return axios.get(url + '/umku-inspeksi-data-checklist/' + idInspeksi)
    }

    listUmkuChecklistByIdInspeksi(idInspeksi) {
        return axios.get(url + '/umku-inspeksi-checklist/' + idInspeksi)
    }

    listUmkuChecklistByIdInspeksiAndNilai(idInspeksi, nilai) {
        return axios.get(url + '/umku-inspeksi-checklist/' + idInspeksi + '/' + nilai)
    }

    getUmkuInspeksiChecklistById(id) {
        return axios.get(url + '/umku-inspeksi-data-checklist-by-id/' + id)
    }

    saveUmkuInspeksiChecklist(jsonData) {
        return axios.post(url + '/umku-inspeksi-data-checklist', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    deleteUmkuInspeksiChecklist(id) {
        return axios.delete(url + '/umku-inspeksi-data-checklist-delete/' + id)
    }

    listUmkuHasilInspeksiByIdInspeksi(idInspeksi) {
        return axios.get(url + '/umku-hasil-inspeksi?idInspeksi=' + idInspeksi)
    }

    saveUmkuHasilInspeksi(jsonData) {
        return axios.post(url + '/umku-hasil-inspeksi', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    getUmkuHasilInspeksiByAjuAndIdInspeksi(nomorAju, idInspeksi) {
        return axios.get(url + '/umku-hasil-inspeksi-by-aju/' + nomorAju + '/' + idInspeksi)
    }

    //evaluasi
    listUmkuEvaluasiByIdInspeksi(idInspeksi) {
        return axios.get(url + '/umku-inspeksi-evaluasi/' + idInspeksi)
    }

    getUmkuEvaluasiById(id) {
        return axios.get(url + '/umku-inspeksi-evaluasi-by-id/' + id)
    }

    saveUmkuEvaluasi(jsonData) {
        return axios.post(url + '/umku-inspeksi-evaluasi', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    deleteUmkuEvaluasiById(id) {
        return axios.delete(url + '/umku-inspeksi-evaluasi/' + id)
    }

    deleteUmkuEvaluasiByAju(nomorAju) {
        return axios.post(url + '/umku-inspeksi-evaluasi-delete-by-aju/' + nomorAju, null, null)
    }

    //rekom
    listUmkuRekomByIdInspeksi(idInspeksi) {
        return axios.get(url + '/umku-inspeksi-rekom/' + idInspeksi)
    }

    getUmkuRekomByIdInspeksiAndAju(idInspeksi, nomorAju) {
        return axios.get(url + '/umku-inspeksi-rekom-by-id-aju/' + idInspeksi + '/' + nomorAju)
    }

    getUmkuRekomById(id) {
        return axios.get(url + '/umku-inspeksi-rekom-by-id/' + id)
    }

    saveUmkuRekom(jsonData) {
        return axios.post(url + '/umku-inspeksi-rekom', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    deleteUmkuRekomById(id) {
        return axios.delete(url + '/umku-inspeksi-rekom/' + id)
    }

    //approval
    listUmkuApprovalByIdInspeksi(idInspeksi) {
        return axios.get(url + '/umku-inspeksi-approval/' + idInspeksi)
    }

    getUmkuApprovalById(id) {
        return axios.get(url + '/umku-inspeksi-approval-by-id/' + id)
    }

    getUmkuApprovalByAju(nomorAju) {
        return axios.get(url + '/umku-inspeksi-approval-by-aju/' + nomorAju)
    }

    saveUmkuApproval(jsonData) {
        return axios.post(url + '/umku-inspeksi-approval', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    deleteUmkuApprovalById(id) {
        return axios.delete(url + '/umku-inspeksi-approval/' + id)
    }

    getMandatoryUpt(kodeUpt) {
        return axios.get(url + '/get-upt-mandatory/' + kodeUpt)
    }

    //jenis-grade
    listJenisGrade(kodeSert, uraianGrade, page, size) {
        let param = ''
        if (uraianGrade !== null) {
            param += '&uraianGrade=' + uraianGrade
        }
        return axios.get(url + '/jenis-grade?page=' + page + '&size=' + size + '&kodeSert=' + kodeSert + param)
    }

    getJenisGrade(kodeSert, kodeGrade) {
        return axios.get(url + '/jenis-grade/' + kodeSert + '/' + kodeGrade)
    }
}